import { CText } from '@bm-js/atlascloud-ui'
import { useWebsite } from '../utils/hooks'
import { Card, CardBody, CardHeader } from '@heroui/card'
import { Select, SelectItem } from '@heroui/select'
import { SharedSelection } from '@heroui/system'
import { useMemo, useState } from 'react'
import { ReportContext, SingleValueReportContext } from '@bm-js/atlas-analytics'
import { PeriodOption, getDateQuery } from '../utils/analytics.utils'
import AnalyticsDisplay from './AnalyticsDisplay'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const WebsiteAnalytics = () => {
  const { anyWebsite } = useWebsite()
  const { tr } = useTr()

  const periodOptions: { label: string; key: PeriodOption }[] = [
    { label: tr(TrKey.analyticsPeriodLastWeek), key: PeriodOption.LastWeek },
    {
      label: tr(TrKey.analyticsPeriodLast2Weeks),
      key: PeriodOption.Last2Weeks,
    },
    {
      label: tr(TrKey.analyticsPeriodLast30Days),
      key: PeriodOption.Last30Days,
    },
  ]

  const [period, setPeriod] = useState<SharedSelection>(
    new Set([PeriodOption.LastWeek])
  )

  // Todo: replace with value set from admin
  const singleValueAnalyticsContexts: SingleValueReportContext[] = [
    SingleValueReportContext.totalPageViews,
    SingleValueReportContext.uniqueUsers,
    SingleValueReportContext.avgEngagementTime,
  ]
  const graphAnalyticsContexts: ReportContext[] = [
    ReportContext.uniqueUsersOverTime,
    ReportContext.avgEngagementTimeOverTime,
    ReportContext.usersPerDevice,
    ReportContext.usersPerRoute,
  ]

  const periodValue = useMemo(() => {
    return Array.from(period)[0] as PeriodOption
  }, [period])

  if (!anyWebsite?.atlasAnalyticsReporterId) return null
  return (
    <div>
      <div className='flex justify-between items-end mb-4'>
        <CText tag='h1' className='text-2xl'>
          {tr(TrKey.analyticsTitle)}
        </CText>
        <Select
          className=' w-48'
          variant='underlined'
          aria-label={tr(TrKey.analyticsPeriod)}
          items={periodOptions}
          selectedKeys={period}
          onSelectionChange={setPeriod}
        >
          {periodOptions.map((option) => (
            <SelectItem key={option.key}>{option.label}</SelectItem>
          ))}
        </Select>
      </div>
      <Card>
        <CardHeader>
          <CText tag='h2' className='text-xl'>
            {tr(TrKey.analyticsOverview)}
          </CText>
        </CardHeader>
        <CardBody>
          <div className='flex gap-2 md:flex-row flex-col'>
            {singleValueAnalyticsContexts.map((context) => (
              <AnalyticsDisplay
                key={`singleValue-${context}`}
                type='singleValue'
                context={context}
                dateQuery={getDateQuery(periodValue)}
              />
            ))}
          </div>
        </CardBody>
      </Card>
      <div className='grid md:grid-cols-2 gap-4 mt-4'>
        {graphAnalyticsContexts.map((context) => (
          <AnalyticsDisplay
            key={`graph-${context}`}
            type='graph'
            context={context}
            dateQuery={getDateQuery(periodValue)}
          />
        ))}
      </div>
    </div>
  )
}

export default WebsiteAnalytics
